import React from "react"
import Button from "@convertkit/design/button"
import useRebrand from "hooks/use-rebrand"

export default function TrialNav({ userInfo, daysLeft }) {
  const rebrand = useRebrand()
  const showCountdown = userInfo.trialing
  const showUpgradeButton = userInfo.trialing

  return (
    <React.Fragment>
      <div className="flex">
        {showCountdown && (
          <div className="my-auto mx-5 text-black">
            Trial: {daysLeft} remaining
          </div>
        )}

        {showUpgradeButton && (
          <Button
            {...(rebrand ? { is: "primary" } : { color: "green" })}
            size="sm"
            href="/upgrade"
          >
            Upgrade now
          </Button>
        )}
      </div>
    </React.Fragment>
  )
}
